import * as React from 'react';
import * as UserActionCreators from "../../actions/user.actions";
import * as classNames from "classnames";
import * as DTOS from "../../FeralScan.dtos";
import { withTheme } from '../../common/withTheme';
import { } from '../Common/validators';
import ContentContainer from '../Content/ContentContainer';
import { bindActionCreators } from 'redux';
import { IAppState } from '../../app';
import { connect } from 'react-redux';
import InternalAbsoluteLink from '../Framework/Common/Links/InternalAbsoluteLink';
import Alert from '../Content/Alert';
import Loader from 'react-loaders';

interface ActivateAccountProps {
    theme?: string,
    currentUser: DTOS.User,
    loginActive: boolean,
    activateAccountToken: string
}

interface IActivateAccountPropsMapped {
    accountActivated?: boolean
}

interface ActivateAccountActions {
    activateAccount(token: string): void

    sendActivateAccount?: typeof UserActionCreators.sendActivateAccount,
}

export type ActivateAccountPropsAndActions = ActivateAccountProps & IActivateAccountPropsMapped & ActivateAccountActions;

interface IActivateAccountState {
    showRequestMade: boolean;
    showJustRegistered: boolean;
}

class ActivateAccount extends React.PureComponent<ActivateAccountPropsAndActions, IActivateAccountState> {
    formDispatch;
    constructor(props, context) {
        super(props, context);

        this.state = {
            showRequestMade: false,
            showJustRegistered: false
        }
    }

    componentDidMount() {
        if (this.props.loginActive) {
        }
        else if (this.props.activateAccountToken) {
            this.props.activateAccount(this.props.activateAccountToken);
            this.setState({
                showRequestMade: true
            })
            //this.props.changeTab(Configuration.SurveyTab)
        } else {
            this.setState((state, props) => {
                return { showJustRegistered: true }
            });
        }
    }

    render() {
        const loggedIn: boolean = this.props.currentUser && this.props.loginActive;

        const alertType = this.props.accountActivated || loggedIn ? 'success' : 'warning';
        const alertMessage = this.props.accountActivated || loggedIn ? 'Your account has been activated. You may now login.'
            : 'Invalid account activation link';

        const accountActivationMessage = this.props.accountActivated || loggedIn ?
            InternalAbsoluteLink("login", "Login", undefined, "btn btn-primary btn-lg col-md-4 offset-md-4 col-md-4 col-12 my-4 w-60")
            : <>
                <p>If you are having trouble activating your account, you can request another verification email by {
                    InternalAbsoluteLink(
                        "/user/activate/resend",
                        "clicking here",
                        undefined,
                        "")}
                    .
                        </p>
                <p>If you have already activated your account {
                    InternalAbsoluteLink(
                        "/user/login",
                        "click here ",
                        undefined,
                        "")}
                    to login.
                        </p>
            </>;

        const registerSuccessMessage = <div className="text-center">
            <h3>Thank you for registering.</h3>
            <p>An email will be sent to your email address, click the link in the email to verify your email
                address and login to the website. Please be patient, this can take a few minutes to arrive.</p>
            {InternalAbsoluteLink("", "Return to the home page", undefined, "btn btn-primary btn-lg my-4 col-md-4 w-60")}

            {InternalAbsoluteLink("/user/activate/resend", "I didn't receive the email", undefined, "btn btn-primary btn-lg my-4 offset-md-4 col-md-4 w-60")}
        </div>;

        const requestMadeMessage = <div className={classNames(this.props.theme, "text-center account-request-text")}>
            <h3>We have sent instructions on how to activate your account to your email address. Please be patient, this can take a few minutes to arrive.</h3>
            {InternalAbsoluteLink("", "Return to site", undefined, "btn btn-lg btn-primary my-4")}
        </div>;

        return (<>
            <div className="row">
                <div className="col-12">
                    {
                        this.props.accountActivated === undefined && this.state.showRequestMade ? <div className="d-flex justify-content-center my-5"
                            style={{ opacity: 0.75, zIndex: 80, bottom: '15px' }}>
                            <Loader type="ball-scale-multiple" active />
                            <div className="ml-4">Activating account</div>
                        </div> : <>
                                <Alert
                                    icon={"fa-warning"}
                                    title={alertMessage}
                                    type={alertType}
                                />
                                {accountActivationMessage}
                            </>
                    }
                </div>
            </div>
            {
                /*
                this.state.showJustRegistered ? registerSuccessMessage : undefined
            }
            {
                this.state.showRequestMade ? requestMadeMessage : undefined
            }
            {
                this.props.activateAccountToken || loggedIn ? accountActivationMessage : undefined
                */
            }
        </>
        );
    }
}


const mapStateToProps = (state: IAppState, ownProps: ActivateAccountPropsAndActions): IActivateAccountPropsMapped => {

    return {
        accountActivated: state.user.accountActivated,
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        sendActivateAccount: UserActionCreators.sendActivateAccount,
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(withTheme<ActivateAccountPropsAndActions>(ActivateAccount));